<template>
   <div class="container">
    <div class="row pb-4 pt-5"  id="logo">
      <div class="col-md-4 pb-3">
      <img src="/img/logo.png" alt="">
    </div>
    <div class="col-md-8 pb-3 d-flex align-items-end justify-content-end">
      <h2>ADALAR MÜZESİ KÜTÜPHANESİ</h2>
    </div>
    </div>
   </div>
 <div class="container">
  <router-view/>
 </div>
</template>

<style>
:root{
  --app-background:rgb(244,244,244);
  --tema-renk01:#e23c00;
}
body,html,#kutuphane{
  font-size: 14px !important;
  background-color: var(--app-background);
  font-family: proxima-nova, sans-serif !important;
font-weight: 400;
font-style: normal;

}
h2{
  font-size: 1.6rem !important;
  font-weight: 700 !important;
}
#app {
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: var(--app-background);
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
#logo img{
width: auto;
height: 80px;
}
</style>
